import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { authActions } from "../../core/auth";
import { updateSection } from "../../core/section/actions";
import Header from "../components/header";
import Banner from "../components/banner";
import StickyHeader from "../components/stickyHeader";
import scroller from "../scroller";
import Footer from "../components/footer";
import "sanitize.css/sanitize.css";
import "./styles.css";
import mineman from "./assets/mineman.png";

export class App extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired,
    signOut: PropTypes.func.isRequired,
  };

  state = {
    showSticky: false,
    page: null,
  };

  componentDidMount() {
    window.twttr = (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0],
        p = /^http:/.test(d.location) ? "http" : "https";
      if (!d.getElementById(id)) {
        js = d.createElement(s);
        js.id = id;
        js.src = p + "://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
      }
    })(document, "script", "twitter-wjs");

    window.addEventListener("scroll", () => {
      if (scroller.elementVerticalClientPositionById("pricing") < 500) {
        this.props.updateSection("pricing");
      } else if (
        scroller.elementVerticalClientPositionById("testimonials") < 500
      ) {
        this.props.updateSection("testimonials");
      } else if (scroller.elementVerticalClientPositionById("features") < 500) {
        this.props.updateSection("features");
      } else {
        this.props.updateSection(null);
      }

      const mainHeaders = document.getElementById("main-headers");
      var offsetHeight = 0;
      if (mainHeaders) {
        offsetHeight = mainHeaders.offsetHeight;
      }

      if (
        /*window.pageYOffset < lastScroll && */ // Uncomment to make sticky only appear when scrolling up
        this.props.routing.locationBeforeTransitions.pathname !== "/admin" &&
        window.pageYOffset > offsetHeight + 20
      ) {
        this.setState({ showSticky: true });
      } else {
        this.setState({ showSticky: false });
      }
    });
  }

  componentWillUpdate(nextProps) {
    const { section, routing } = nextProps;
    const { page } = this.state;
    if (routing.locationBeforeTransitions.pathname === "/") {
      if (section === "faq" && page !== "faq") {
        this.setState({ page: "faq" });
      } else if (section === "testimonials" && page !== "testimonials") {
        this.setState({ page: "testimonials" });
      } else if (section === "features" && page !== "features") {
        this.setState({ page: "features" });
      } else if (section === "pricing" && page !== "pricing") {
        this.setState({ page: "pricing" });
      } else if (section === null && page !== "features") {
        this.setState({ page: "features" });
      }
    }

    if (
      routing.locationBeforeTransitions.pathname === "/download" &&
      page !== "download"
    ) {
      this.setState({ page: "download", showSticky: false });
    }

    if (
      routing.locationBeforeTransitions.pathname === "/buy" &&
      page !== "buy"
    ) {
      this.setState({ page: "buy", showSticky: false });
    }

    if (
      routing.locationBeforeTransitions.pathname === "/terms" &&
      page !== "terms"
    ) {
      this.setState({ page: "terms" });
    }

    if (
      routing.locationBeforeTransitions.pathname === "/privacy" &&
      page !== "privacy"
    ) {
      this.setState({ page: "privacy" });
    }

    if (
      routing.locationBeforeTransitions.pathname === "/affiliate" &&
      page !== "affiliate"
    ) {
      this.setState({ page: "affiliate" });
    }
  }

  componentDidUpdate() {}

  hideStickyAfterClick = () => this.setState({ showSticky: false });

  render() {
    return this.props.routing.locationBeforeTransitions.pathname ===
      "/admin" ? (
      this.props.children
    ) : (
      <div className="App">
        <Helmet>
          <title>Ghast.io: How to Play Minecraft Pro PvP Like A Kohi God</title>
          <meta
            name="description"
            content="Ghast Lag fix is the BEST Software for Improving Your Minecraft Connection, Shown to provide a BRUTAL combination of ..."
          />
        </Helmet>
        {this.props.routing.locationBeforeTransitions.pathname === "/" ? (
          <div id="main-headers">
            <div>
              <Header
                page={this.state.page}
                authenticated={this.props.auth.authenticated}
                premium={this.props.premium}
                signInWithGoogle={this.props.signInWithGoogle}
                signOut={this.props.signOut}
                user={this.props.user}
              />
              <Banner
                loggedIn={this.props.auth.authenticated}
                signInWithGoogle={this.props.signInWithGoogle}
              />
              <img src={mineman} className="mineman" alt="mineman" />
              {/*<SecondaryHeader
              authenticated={this.props.auth.authenticated}
              premium={this.props.premium}
              signOut={this.props.signOut}
              user={this.props.user}
            />*/}
            </div>
          </div>
        ) : null}
        <StickyHeader
          visible={
            this.props.routing.locationBeforeTransitions.pathname === "/"
              ? this.state.showSticky
              : true
          }
          hideStickyAfterClick={this.hideStickyAfterClick}
          authenticated={this.props.auth.authenticated}
          premium={this.props.premium}
          affiliate={this.props.user.affiliate}
          signInWithGoogle={this.props.signInWithGoogle}
          signOut={this.props.signOut}
          page={this.state.page}
          home={
            this.props.routing.locationBeforeTransitions.pathname === "/"
              ? true
              : false
          }
        />

        {this.props.children}

        <Footer premium={this.props.premium} />
      </div>
    );
  }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user,
  premium: state.premium,
  section: state.section,
  routing: state.routing,
});

export default connect(mapStateToProps, { ...authActions, updateSection })(App);



/** WEBPACK FOOTER **
 ** ./src/views/app/index.js
 **/